const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-e27f81bf-ad3d-494e-9e21-4923cc31b58c {\n        fill: #5e3524;\n      }\n\n      .uuid-1eb6ead4-e2b0-4d03-a965-6fb767bdaf73 {\n        stroke-linecap: round;\n      }\n\n      .uuid-1eb6ead4-e2b0-4d03-a965-6fb767bdaf73, .uuid-738680f6-d661-4339-88b2-b76208d442b8, .uuid-abbdc6a7-c706-44f4-a6c6-2ef7bafd097b {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-miterlimit: 10;\n      }\n\n      .uuid-1eb6ead4-e2b0-4d03-a965-6fb767bdaf73, .uuid-abbdc6a7-c706-44f4-a6c6-2ef7bafd097b {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-234f9a86-0ac7-4223-b7c3-e037dcfe6f31",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-e27f81bf-ad3d-494e-9e21-4923cc31b58c",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-411e0474-3133-4a01-8ec9-41ea34e75d43",
  "data-name": "Template"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-738680f6-d661-4339-88b2-b76208d442b8",
  d: "M15.1,22.52l-3.07,10.8c-2.82-1.1-4.38-4.09-3.58-6.89.33-1.19,1.05-2.2,2.02-2.91,1.28-.93,2.95-1.33,4.63-1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-abbdc6a7-c706-44f4-a6c6-2ef7bafd097b",
  d: "M19.65,22.9l-3.55,12.5c-.09.31-.4.48-.7.39l-2.69-.78c-.27-.08-.44-.34-.4-.62l3.58-12.61c.1-.28.4-.44.68-.36l2.7.78c.29.09.46.4.38.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-abbdc6a7-c706-44f4-a6c6-2ef7bafd097b",
  d: "M31.25,35.01l-2.69.78c-.3.09-.61-.08-.7-.39l-3.55-12.5c-.08-.3.09-.61.38-.7l2.7-.78c.3-.08.61.09.69.39l.06.22h0s.13.43.13.43l3.37,11.87c.07.3-.1.6-.39.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-738680f6-d661-4339-88b2-b76208d442b8",
  d: "M31.92,33.28l-3.07-10.79c.79-.16,1.58-.16,2.35-.01l.32.06c1.88.5,3.43,1.91,3.99,3.85.81,2.84-.77,5.82-3.59,6.89Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-738680f6-d661-4339-88b2-b76208d442b8",
  x1: 11.7,
  y1: 18.89,
  x2: 11.7,
  y2: 22.84
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-738680f6-d661-4339-88b2-b76208d442b8",
  x1: 32.68,
  y1: 19.09,
  x2: 32.68,
  y2: 22.99
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-1eb6ead4-e2b0-4d03-a965-6fb767bdaf73",
  d: "M11.7,18.89c0-5.79,4.7-10.49,10.49-10.49s10.49,4.7,10.49,10.49"
}));
function SvgRepozeIconCategoryTechnology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryTechnology);
export default __webpack_public_path__ + "static/media/repoze_icon_category-technology.79bb3768d238b56275d5aae7329556fd.svg";
export { ForwardRef as ReactComponent };